import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import DeleteGroup from 'modules/posts/components/Groups/Delete'

const DeleteGroupPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <DeleteGroup onClose={() => navigate(navigation.dashboard.fullPath())} groupId={Number(id)} />
  )
}

export default DeleteGroupPage
